import { Component, OnInit, Inject, Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule, Location } from '@angular/common';
import { BoxService } from 'src/app/shared/services/box.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ObjectExplorerService } from 'src/app/shared/object-explorer/object-explorer.service';
import { InputparameterDialogComponent } from '../inputparameter-dialog/inputparameter-dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ListPanelModule } from 'src/app/bloom/specialized-panels/list-panel/list-panel.module';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { WidgetManager } from 'src/app/bloom/models/WidgetManager';
import { BoxInstance } from 'src/app/core/boxInstances/BoxInstance';
import { CacheService } from 'src/app/core/services/CacheService';
import { TokenUtil } from 'src/app/core/services/TokenUtil.service';

@Component({
    selector: 'actions-listing',
    templateUrl: './actions-listing.component.html',
    styleUrls: ['./actions-listing.component.css'],
    imports: [MatTooltipModule, MatExpansionModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatChipsModule, FlexLayoutModule, CommonModule, ListPanelModule, SpinnerModule]
})

export class ActionsListingComponent implements OnInit {
  constructor(
    private token: TokenUtil,
    private cs: CacheService,
    private dialog: MatDialog,
    private location: Location,
    private boxService: BoxService,
    private objectExplorerService: ObjectExplorerService
  ) {}

  @Input() connection: any
  @Input() starch: any
  @Input() box: any

  actions: any[] = []
  filteredActions: any[] = []
  actionResults: { action: any, result: any[], isExpanded: boolean }[] = []  // array containing the results of all the executed functions
  openResultIndex: number = -1 
  actionsLoaded: boolean = false
  spinner: boolean = false
  crudTypeMap: any = { R: "Read", C: "Create", U: "Update", E: "Execute", D: "Delete", S: "Save" }

  listPanelMeta = {
    type: "listpanel",
    viewTypes: {
      defaultView: "card",
      card: { cardSize: "small" }
    },
    listPanelTitle: ' ',
    listAttributes: [
      {
        __id: "logo",
        name: "logo",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'image',
        isColumnSelected: true
      },
      {
        __id: "action_logo",
        name: "Action logo",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'image',
        isColumnSelected: true
      },
      {
        __id: "name",
        name: "Name",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'label',
        isColumnSelected: true
      },
      {
        __id: "description",
        name: "Description",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'label',
        isColumnSelected: true
      },
      {
        __id: "crudType",
        name: "Crud Type",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'tags',
        isColumnSelected: true
      },
    ],
    listWidgetSet: {}
  };

  ngOnInit(): void {
    console.log("connection", this.connection)
    console.log("box", this.box)
    this.getActions()

    this.setWidgetStyles()
  }

  setWidgetStyles(){
    let logoWidget = WidgetManager.getWidget('image')
    let action_logo = WidgetManager.getWidget('image')
    logoWidget.config.width.value = '20%'
    action_logo.config.width.value = '60%'
    logoWidget.config.imageAlignment.value = "left"
    this.listPanelMeta.listWidgetSet['logo'] = logoWidget
    action_logo.config.value.value = "https://storage.googleapis.com/jivrus-web-images/products/appiworks/connection/aw-connection-action-logo.png"
    action_logo.config.value.resetValue = "https://storage.googleapis.com/jivrus-web-images/products/appiworks/connection/aw-connection-action-logo.png"
    this.listPanelMeta.listWidgetSet['action_logo'] = action_logo
    console.log("logoWidget, action_logo", action_logo)

    // text formatting for object name
    let nameWid = WidgetManager.getWidget('label')
    nameWid.textFormat.bold.value = true
    nameWid.textFormat.fontSize.value = 16
    nameWid.textFormat.color.value = "#3f51b5"
    nameWid.config.alignment.value = "center"
    this.listPanelMeta.listWidgetSet['name'] = nameWid
    
  }

  async getActions() {
    // if (this.connectionService.actionsCache?.[this.connection._id]?.length){
    //   this.actions = this.connectionService.actionsCache?.[this.connection._id]
    //   console.log("cache retrieved", this.connectionService.actionsCache?.[this.connection._id])
    // } else {
    // }
    this.spinner = true
    try {

      let cachedActions = await this.checkCache()
      if(cachedActions){
        this.actions = cachedActions.functions
        console.log("cached actions retrieved", this.actions)
      }else{
        this.actions = await this.boxService.getBoxActions(
          this.connection.box_id,
          this.connection.box_token,
          "token"
        );
      }
      // set cache
      // if(this.actions?.length) {
      //   this.connectionService.actionsCache[this.connection._id] = this.actions
      // }
      this.spinner = false
    } catch (error) {
      this.spinner = false
      console.error('Could not fetch actions :', error);
    }
    console.log('ACTIONS', JSON.parse(JSON.stringify(this.actions)));
    // this.filteredActions = JSON.parse(JSON.stringify(this.actions))
    this.assignAllActions()
    this.actionsLoaded = true
  }

  async checkCache(){
    let chOptions: any = {keyPrefix: "box_actions_", isLocalStorage: false, clearCache: false, "avoidAuthKey": true};
    let boxUrl = `/${this.box.__id}/functions`;
    let baseUrl = await BoxInstance.getInstance( boxUrl );
    let token = this.token.getStatelessToken()
    const headers = {
      boxConfigToken: this.connection.box_token,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const cacheKey = this.cs.getCacheKey(baseUrl + boxUrl, { headers: headers }, null, chOptions);
    let cachedData = this.cs.getData(cacheKey, chOptions)
    if(cachedData) return cachedData
  }

  assignAllActions(){
    this.actions.forEach(action => {
      this.filteredActions.push({
        logo: this.box.logo,
        name: action.name,
        description: action.description || "",
        crudType: this.crudTypeMap[action.crudType] || ""
      })
    })
  }
  trackByFn(index:number, item:any):any{
    return item || index
  }

  searchActions(event: any){
    if(event.srcElement.value == ''){
      this.assignAllActions()
      return
      // this.filteredActions = JSON.parse(JSON.stringify(this.actions))
      // if(this.filteredActions.length > 15){
      //   this.filteredActions = this.filteredActions.slice(0, 15)
      // }
      // return
    }
    this.filteredActions = []
    for (let i = 0; i < this.actions.length; i++) {
      if(this.actions[i].name.toLowerCase().includes(event.srcElement.value)){
        this.filteredActions.push({
          logo: this.box.logo,
          name: this.actions[i].name,
          description: this.actions[i].description || "",
          crudType: this.crudTypeMap[this.actions[i].crudType] || ""
        })
      }
    }
  }

  // executeAction(id){
  //   console.log("execute action", id)
  // }

  async executeAction(clickAction) {
    // console.log("execute action", clickAction.index)
    if(typeof clickAction.index !== 'number' || clickAction.index < 0) return
    let action = this.actions.find(a => a.name == this.filteredActions[clickAction.index].name)
    console.log("action to execute", action)
    if (action.input?.list) {
      var dialog = this.dialog.open(InputparameterDialogComponent, {
        minWidth: '60%',
        data: {
          action: action,
          getAttributesFunction: this.actions.find(
            (fn) => fn.__id == 'getattributes'
          ),
          connection: this.connection,
          isOnlyOptions: false
        },
      });
      result = await dialog.afterClosed().toPromise();
    } else {
      var result = await this.boxService.executeBoxFunction(
        this.connection._id,
        this.connection.box_id,
        action.__id,
        undefined,
        this.connection.box_token
      );
      console.log("action result", result)
      // var result = await this.boxService.executeBoxObjectFunction(
      //   this.connection._id,
      //   this.connection.box_id,
      //   action.__id
      // );
      if(result && result?.data) result = result?.data
    }

    if(!Array.isArray(result)) result = [result]
    console.log(result);
    this.actionResults.unshift({
      action: action,
      result: result,
      isExpanded: true
    })
    this.openResultIndex = this.actionResults.length - 1
  }

  deleteResult(i){
    this.actionResults.splice(i, 1)
  }

  // rowClicked(data){
  //   console.log("action clicked", data)
  //   let clickedObject = this.actions.find(obj => obj.name == data.data.name.value)
  //   this.exploreAction(clickedObject.__id)
  // }
}
